<div class="item">
  <h3 style="margin: 0px;">{{product.name}}</h3>
  <p style="margin: 0px">{{product.price | currency : 'USD' : 'symbol' : '1.0-0'}}</p>
</div>
